<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g transform="translate(-18 0.197)">
      <rect
        width="16"
        height="16"
        transform="translate(18 -0.197)"
        fill="none"
      />
      <g transform="translate(-2 -0.197)">
        <path
          d="M96.779,2.8H91.445A.433.433,0,0,1,91,2.381V1.54a.433.433,0,0,1,.445-.42A1.063,1.063,0,0,0,92.486.352L92.5.318A.441.441,0,0,1,92.926,0H95.3a.441.441,0,0,1,.431.318l.009.033a1.063,1.063,0,0,0,1.042.769.433.433,0,0,1,.445.42v.84A.433.433,0,0,1,96.779,2.8Z"
          transform="translate(-68.08 0.852)"
          opacity="0.6"
        />
        <path
          d="M28.558,63.42a.576.576,0,0,0,.523-.312l.063-.121a1.332,1.332,0,0,1,1.193-.711h1.037v-.715a1.306,1.306,0,0,0-1.186-1.278v.706a1.312,1.312,0,0,1-1.334,1.286H23.519a1.312,1.312,0,0,1-1.334-1.286v-.706A1.306,1.306,0,0,0,21,61.562V71.909A1.312,1.312,0,0,0,22.334,73.2H30.04a1.33,1.33,0,0,0,1.281-.929,1.382,1.382,0,0,1-.183-.039,5.457,5.457,0,0,1-2.828-1.912,5.137,5.137,0,0,1-1.086-3.162V64.706A1.312,1.312,0,0,1,28.558,63.42Zm-2.95,6.261L23.931,71.3a.456.456,0,0,1-.629,0l-.838-.808a.418.418,0,0,1,0-.606.456.456,0,0,1,.629,0l.524.505,1.362-1.314a.473.473,0,0,1,.629,0A.432.432,0,0,1,25.607,69.681Zm0-3.05-1.677,1.617a.456.456,0,0,1-.629,0l-.838-.808a.418.418,0,0,1,0-.606.456.456,0,0,1,.629,0l.524.505,1.362-1.314a.456.456,0,0,1,.629,0A.418.418,0,0,1,25.607,66.631Zm0-3.05L23.931,65.2a.456.456,0,0,1-.629,0l-.838-.808a.418.418,0,0,1,0-.606.456.456,0,0,1,.629,0l.524.505,1.362-1.314a.456.456,0,0,1,.629,0A.418.418,0,0,1,25.607,63.58Z"
          transform="translate(0 -57.743)"
        />
        <path
          d="M267.372,161.12a1.477,1.477,0,0,1-1.318-.77l-.063-.118a.448.448,0,0,0-.4-.232h-2.371a.448.448,0,0,0-.4.232l-.063.118a1.477,1.477,0,0,1-1.318.77.433.433,0,0,0-.445.42v2.4a4.165,4.165,0,0,0,.91,2.6,4.578,4.578,0,0,0,2.371,1.57.469.469,0,0,0,.255,0,4.578,4.578,0,0,0,2.37-1.57,4.165,4.165,0,0,0,.91-2.6v-2.4A.433.433,0,0,0,267.372,161.12Zm-1.392,2.446L264.3,165.15a.463.463,0,0,1-.629,0l-.838-.792a.4.4,0,0,1,0-.594.463.463,0,0,1,.629,0l.524.5,1.362-1.287a.463.463,0,0,1,.629,0A.4.4,0,0,1,265.98,163.566Z"
          transform="translate(-232.817 -154.406)"
          opacity="0.6"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "write-off-icon",
};
</script>
